require('angular')
require('../../../core/translation/translation-module')
BrowserService = require('./browser-service')
BrowserInterceptor = require('./browser-interceptor')

angular.module 'gnp-browser', ['gnp-translation']
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
    .translations 'en', require('./i18n/en')
    .translations 'ja', require('./i18n/ja')
  ]
  .factory 'BrowserService', BrowserService
  .run BrowserInterceptor


// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/browser/browser-module.coffee